import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45fbe25c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-page" }
const _hoisted_2 = { class: "page-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "admin-title" }, "Guesser Admin", -1))
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Current Season", -1))
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-center py-4"
}
const _hoisted_7 = {
  key: 1,
  class: "stats-row"
}
const _hoisted_8 = { class: "stat-box" }
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Games Played", -1))
const _hoisted_11 = { class: "stat-box" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Wins", -1))
const _hoisted_14 = { class: "stat-box" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Players", -1))
const _hoisted_17 = { class: "stat-box" }
const _hoisted_18 = { class: "stat-value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Top Player", -1))
const _hoisted_20 = { class: "section" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Reset Season", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "This permanently deletes all scores and wipes the leaderboard. There is no undo.", -1))

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { userService } from '@/services/user.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuesserAdminView',
  setup(__props) {

const confirmDialog = ref(false);
const resetting = ref(false);
const resetSuccess = ref(false);
const resetError = ref('');
const statsLoading = ref(false);

const stats = ref({ totalGames: 0, totalWins: 0, uniquePlayers: 0, topPlayer: '' });

function authHeaders() {
    return { Authorization: 'Bearer ' + userService.jwt };
}

async function loadStats() {
    statsLoading.value = true;
    try {
        const resp = await axios.get('/api/guesser/leaderboard');
        const rows = resp.data;
        stats.value = {
            totalGames: rows.reduce((s: number, r: any) => s + r.games_played, 0),
            totalWins: rows.reduce((s: number, r: any) => s + r.wins, 0),
            uniquePlayers: rows.length,
            topPlayer: rows[0]?.display_name || rows[0]?.twitch_id || '',
        };
    } catch (e) {
        console.error('Failed to load stats', e);
    } finally {
        statsLoading.value = false;
    }
}

async function resetSeason() {
    resetting.value = true;
    resetSuccess.value = false;
    resetError.value = '';
    try {
        await axios.delete('/api/guesser/season', { headers: authHeaders() });
        confirmDialog.value = false;
        resetSuccess.value = true;
        await loadStats();
    } catch (e: any) {
        resetError.value = e?.response?.data?.error || 'Failed to reset season.';
    } finally {
        resetting.value = false;
    }
}

onMounted(loadStats);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, {
        class: "admin-card",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "card-header" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "card-body" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                (statsLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary",
                        size: "32"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(stats.value.totalGames), 1),
                        _hoisted_10
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(stats.value.totalWins), 1),
                        _hoisted_13
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(stats.value.uniquePlayers), 1),
                        _hoisted_16
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(stats.value.topPlayer || '—'), 1),
                        _hoisted_19
                      ])
                    ]))
              ]),
              _createVNode(_component_v_divider, { class: "my-4" }),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "outlined",
                  "prepend-icon": "mdi-delete-forever",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmDialog.value = true)),
                  disabled: resetting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Reset Season ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                (resetSuccess.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "success",
                      class: "mt-4",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Season reset successfully. ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (resetError.value)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 1,
                      type: "error",
                      class: "mt-4",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(resetError.value), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: confirmDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmDialog).value = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Reset Season?")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" All "),
                _createElementVNode("strong", null, _toDisplayString(stats.value.totalGames), 1),
                _createTextVNode(" game records and leaderboard scores will be permanently deleted. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  loading: resetting.value,
                  onClick: resetSeason
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Yes, Reset ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})